module.exports = __webpack_public_path__ + "static/img/action-fraud-detection.a56d113.svg";